// const CurrentNAME = 'http://localhost:3000/';
const CurrentNAME = 'https://hugsangbaan.com';
// const APINAME = 'https://api.hugsangbaan.com/files/';

export default CurrentNAME;